(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["euroforless-header"]) return;
  try {
    
  (() => {
    const renderCartCount = (count) => {
      if (!Number.isFinite(count) || count < 0) return;

      document.querySelectorAll('[data-efl-cart-count]').forEach((element) => {
        element.textContent = String(count);
        element.hidden = count === 0;
      });

      document.querySelectorAll('[data-efl-mobile-cart-count]').forEach((element) => {
        element.textContent = ' (' + count + ')';
        element.hidden = count === 0;
      });
    };

    const fetchCartCount = async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) return null;

      const cart = await response.json();
      return Number(cart.item_count);
    };

    document.addEventListener('shopify:cart:lines-update', (event) => {
      Promise.resolve(event.promise)
        .then(async (result) => {
          const eventCount = Number(result?.cart?.totalQuantity);
          const count = Number.isFinite(eventCount) ? eventCount : await fetchCartCount();
          renderCartCount(count);
        })
        .catch(async () => {
          const count = await fetchCartCount();
          renderCartCount(count);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["euroforless-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeInfiniteScroll = (scope = document) => {
      const loaders = scope.querySelectorAll('[data-efl-infinite-scroll]:not([data-efl-initialized])');

      loaders.forEach((loader) => {
        loader.dataset.eflInitialized = 'true';

        const grid = loader.previousElementSibling;
        const button = loader.querySelector('[data-efl-load-more]');
        const status = loader.querySelector('[data-efl-load-status]');
        let loading = false;

        if (!grid || !button || !status) return;

        const observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
          },
          { rootMargin: '800px 0px' }
        );

        const loadNextPage = async () => {
          if (loading || !loader.dataset.nextUrl) return;

          loading = true;
          button.disabled = true;
          button.textContent = loader.dataset.loadingLabel;
          status.textContent = loader.dataset.loadingLabel;

          try {
            const nextUrl = new URL(loader.dataset.nextUrl, window.location.origin);
            nextUrl.searchParams.set('section_id', loader.dataset.sectionId);

            const response = await fetch(nextUrl.toString(), {
              headers: { Accept: 'text/html' },
              credentials: 'same-origin'
            });

            if (!response.ok) throw new Error('Unable to load products');

            const html = await response.text();
            const responseDocument = new DOMParser().parseFromString(html, 'text/html');
            const incomingGrid = responseDocument.querySelector('[data-efl-product-grid]');
            const incomingLoader = responseDocument.querySelector('[data-efl-infinite-scroll]');

            if (!incomingGrid) throw new Error('Product grid was not returned');

            const fragment = document.createDocumentFragment();
            Array.from(incomingGrid.children).forEach((product) => fragment.appendChild(product));
            grid.appendChild(fragment);

            if (incomingLoader && incomingLoader.dataset.nextUrl) {
              loader.dataset.nextUrl = incomingLoader.dataset.nextUrl;
              button.disabled = false;
              button.textContent = incomingLoader.querySelector('[data-efl-load-more]').textContent;
              status.textContent = '';
              observer.observe(loader);
            } else {
              observer.disconnect();
              loader.remove();
            }
          } catch (error) {
            button.disabled = false;
            button.textContent = loader.dataset.errorLabel;
            status.textContent = loader.dataset.errorLabel;
          } finally {
            loading = false;
          }
        };

        button.addEventListener('click', loadNextPage);
        observer.observe(loader);
      });
    };

    initializeInfiniteScroll();
    document.addEventListener('shopify:section:load', (event) => initializeInfiniteScroll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
